import { render, staticRenderFns } from "./textImgContent.vue?vue&type=template&id=f5758796&scoped=true&"
import script from "./textImgContent.vue?vue&type=script&lang=js&"
export * from "./textImgContent.vue?vue&type=script&lang=js&"
import style0 from "./textImgContent.vue?vue&type=style&index=0&id=f5758796&prod&lang=scss&"
import style1 from "./textImgContent.vue?vue&type=style&index=1&id=f5758796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5758796",
  null
  
)

export default component.exports